exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".RWAcontainer {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  border-radius: 16px;\n}\n\n.RwaTable {\n  table-layout: auto;\n  color: #0b0b0a;\n}\n\n.RwaTable th,\n.RwaTable td {\n  border: 1px solid #ebebeb;\n  min-width: 100px;\n  padding: 0 8px;\n}\n\n.RwaTable thead {\n  background-color: #fbc83a;\n}\n\n.RwaTable th {\n  vertical-align: middle !important;\n  text-align: center;\n}\n\n.RwaTable th .unit {\n  font-weight: 400;\n  font-style: italic;\n}\n\n.RwaTable .primaryRow {\n  background-color: #fef1cd !important;\n}\n\n.RwaTable .primaryRow td {\n  font-weight: 600;\n  border: none;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/Report/RWA/style.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/resolve-url-loader/index.js!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/Raroc/Report/RWA/style.scss
// module chunks = 0